import React, { useRef, useState, useEffect, useCallback } from "react";
import { Editor } from "@tinymce/tinymce-react";
import {
  Button,
  Container,
  Col,
  Form,
  Image,
  Nav,
  Row,
  Dropdown,
  Tooltip,
  OverlayTrigger,
  Modal,
  Spinner,
} from "react-bootstrap";
import { debounce } from "lodash"; // Import lodash debounce function
import excl_i from "../../../assets/images/icons/excl_i.png";
import trash from "../../../assets/images/icons/trash.svg";
import edit from "../../../assets/images/icons/edit.svg";
import { useNavigate, NavLink } from "react-router-dom";
import { useUserContext } from "../../../utils/hooks/UserContext";
import {
  coachBGImage,
  coachAddSpeciality,
  coachUpdateSpeciality,
  coachDeleteSpeciality,
  coachUpdate,
  searchSpecialtiesByName,
} from "../../../utils/api";
import Camera from "../../../assets/images/Camera";
import Upload from "rc-upload";
import banner from "../../../assets/images/coach_details_banner.png";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import Loader from "../../../Loader/Loader";
import { PulseLoader } from "react-spinners";

import Cropper from "react-easy-crop";
import getCroppedImg from "../../../utils/getCroppedImg"; // A utility to extract cropped image blob
const validationSchema = Yup.object().shape({
  speciality: Yup.string().required("speciality is required").max(150),
  description: Yup.string().required("description is required").max(500),
});
const initialValues = {
  speciality: "",
  description: "",
};
const DropdownSuggestions = ({ show, suggestions, handleSuggestionSelect }) => (
  <Dropdown show={show} className="mb-0">
    <Dropdown.Menu show={show}>
      {suggestions.length > 0 &&
        suggestions.map((suggestion) => (
          <Dropdown.Item
            key={suggestion.id}
            onClick={() => handleSuggestionSelect(suggestion)}
          >
            {suggestion.name}
          </Dropdown.Item>
        ))}
    </Dropdown.Menu>
  </Dropdown>
);
const EditProfileSpecialties = (props) => {
  const navigate = useNavigate();
  const { getUserFromToken, user } = useUserContext();
  const [specialties, setspecialties] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [selectedSuggestion, setSelectedSuggestion] = useState(null);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [isLoading, setisLoading] = useState(false);
  const [isSubmitting, setisSubmitting] = useState(false);
  const [isSave, setSaved] = useState(false);

  useEffect(() => {
    const canonicalUrl = window.location.origin + window.location.pathname;
    let link = document.querySelector("link[rel='canonical']");
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonicalUrl);

    // const json = JSON.stringify(user?.specialties)
    // console.log(Array.isArray(JSON.parse(user?.specialties)), "----------------------- LIVE");
    setspecialties(JSON.parse(user?.specialties));
  }, [user]);

  const searchSpecialties = async (query) => {
    try {
      const { data } = await searchSpecialtiesByName(query, 1, 5);
      setSuggestions(data?.data);
    } catch (error) {
      console.error("Error fetching suggestions:", error);
    }
  };

  const debouncedSearch = useRef(debounce(searchSpecialties, 300)).current;

  const handleSpecialityChange = (event) => {
    const inputValue = event.target.value;
    formik.handleChange(event); // Handle the formik change event

    // Trigger the debounce search to get suggestions based on the input value
    debouncedSearch(inputValue);
  };

  const onClickSave = async (values) => {
    try {
      // const about = log();
      // const story = storyLog();
      setisSubmitting(true);

      // handle speciality
      const newSpecialities = specialties?.filter((i) => i?.status === "new");
      for (let index = 0; index < newSpecialities?.length; index++) {
        const element = newSpecialities[index];
        const formData = new FormData();

        if (element?.speciality_id) {
          formData.append("speciality_id", element?.speciality_id);
        }

        if (element?.speciality && !element?.speciality_id) {
          formData.append("speciality", element?.speciality);
        }

        formData.append("description", element?.description);

        await coachAddSpeciality(formData);
      }

      const deletedSpecialities = specialties?.filter(
        (i) => i?.status === "deleted"
      );

      if (deletedSpecialities?.length > 0) {
        const formData = new FormData();
        formData.append(
          "speciality_ids",
          `[${deletedSpecialities?.map((i) => i?.id)}]`
        );

        await coachDeleteSpeciality(formData);
        setSaved(false);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message);
      setisSubmitting(false);
    }

    getUserFromToken();
    setisSubmitting(false);
  };

  const handleSubmit = (values, { resetForm }) => {
    formik.setValues({
      ...formik.values,
      speciality: "",
      description: "",
    });

    let newSpeciality = {};

    if (selectedSuggestion) {
      newSpeciality = {
        id: new Date()?.getTime(),
        speciality_id: selectedSuggestion?.id,
        speciality: selectedSuggestion.name,
        description: values.description,
        status: "new",
      };
    } else {
      newSpeciality = {
        id: new Date()?.getTime(),
        speciality: values.speciality,
        description: values.description,
        status: "new",
      };
      setSaved(true);
    }

    setSelectedSuggestion(null);
    setSuggestions([]);
    setspecialties([...specialties, newSpeciality]);
    resetForm();
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
  });

  const onClickRemove = (id) => {
    const results = JSON.parse(JSON.stringify(specialties))?.map((i) => {
      console.log(id, i.id, "090909");

      if (id === i?.id) {
        i.status = "deleted";
      }
      return i;
    });
    setspecialties(results);
  };
  console.log("specialites", specialties);

  return (
    <>
      <Modal
        size="lg"
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <div className="profile_edit_forms my_light_modal">
          {/* <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Modal heading</Modal.Title>
        </Modal.Header> */}
          {/* <Form onSubmit={formik.handleSubmit}> */}
          <Container>
            <Row className="g-3">
              <Col lg="12">
                <div className="d-flex justify-content-between">
                  <Form.Label className="m-0 title">Specialties</Form.Label>
                  <span>
                    <Image src={excl_i} />
                  </span>
                </div>
                <Form onSubmit={formik.handleSubmit}>
                  <>
                    {
                      // ?.filter((i) => i?.status !== "deleted")
                      specialties
                        ?.filter((i) => i?.status !== "deleted")
                        ?.map((specialty, index) => (
                          <Row key={index}>
                            {/* <Col className="mx-auto col-11"> */}
                            <Col className="">
                              <div className="mt-2 d-flex align-items-center justify-content-between">
                                <div>
                                  <h5 className="fs-20 fw-500 text_brand_color7">
                                    {specialty?.speciality}
                                  </h5>
                                  <p className="mb-4 fs-14 fw-400 text_brand_color8">
                                    {specialty?.description}
                                  </p>
                                </div>

                                <div className="d-flex align-items-center">
                                  <Button
                                    className="p-0 m-2"
                                    variant=""
                                    onClick={() => onClickRemove(specialty?.id)}
                                  >
                                    <Image src={trash} />
                                  </Button>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        ))
                    }

                    <Form.Group className="mb-3" controlId="">
                      <Form.Control
                        type="text"
                        name="speciality"
                        value={formik.values.speciality}
                        onChange={handleSpecialityChange}
                        onClick={() => setShowSuggestions(true)}
                        placeholder="Enter Specialty"
                        isInvalid={
                          formik.touched.speciality &&
                          !!formik.errors.speciality
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {formik.errors.speciality &&
                          formik.touched.speciality && (
                            <div>{formik.errors.speciality}</div>
                          )}
                      </Form.Control.Feedback>

                      {/* Show suggestions dropdown */}
                      {showSuggestions && suggestions?.length > 0 && (
                        <DropdownSuggestions
                          show={showSuggestions}
                          suggestions={suggestions}
                          handleSuggestionSelect={(suggestion) => {
                            formik.setFieldValue(
                              "speciality_id",
                              suggestion?.id
                            );
                            formik.setFieldValue(
                              "speciality",
                              suggestion?.name
                            );
                            setSelectedSuggestion(suggestion);
                            setShowSuggestions(false);
                          }}
                        />
                      )}
                    </Form.Group>

                    <Form.Group className="" controlId="">
                      <Form.Control
                        as="textarea"
                        rows={3}
                        name="description"
                        value={formik.values.description}
                        onChange={formik.handleChange}
                        placeholder="Description"
                        isInvalid={
                          (formik.touched.description &&
                            !!formik.errors.description) ||
                          formik.values.description.length >= 250
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {(formik.errors.description &&
                          formik.touched.description) ||
                          (formik.values.description.length >= 250 && (
                            <div>
                              {formik.values.description.length >= 250
                                ? "Max character reached 250"
                                : formik.errors.description}
                            </div>
                          ))}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <div className="mt-3 mb-3 text-center" controlId="">
                      <Button
                        variant="success"
                        className="px-4"
                        type="submit"
                        disabled={
                          !formik.values.description ||
                          !formik.values.speciality
                        }
                      >
                        Add
                      </Button>
                    </div>
                  </>
                </Form>
              </Col>
            </Row>
            <Row className="mt-4 justify-content-end">
              <Col sm="auto">
                <Button
                  variant="success"
                  className="px-5"
                  disabled={!isSave}
                  onClick={isSave ? onClickSave : undefined}
                >
                  Save
                </Button>
              </Col>
            </Row>
          </Container>
          {/* </Form> */}
        </div>
      </Modal>
    </>
  );
};

export default EditProfileSpecialties;
